import { applicationApi } from 'common/api';
import { StatisticResponse } from 'models/statistic';

// Define a service using a base URL and expected endpoints
export const statisticApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getStatistic: builder.query<StatisticResponse, void>({
      query: () => `bdc/statistic`,
      providesTags: [{ type: 'Statistic', id: 'Statistic' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetStatisticQuery } = statisticApi;
